import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=32ae0ecd&scoped=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae0ecd",
  null
  
)

export default component.exports